import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import { Coffee } from "lucide-react";
import { useScheduleContext } from "../../../../../../hooks/context/useScheduleContext";
import { useCompanyTimeFormat } from "../../../../../../../../../utils/hooks/company";
import { renderDurationAsFormat } from "../../../../../../../../../utils/helpers/date";

function AutomaticBreaksDisplay({ breaks }: any) {
    const { t } = useTranslation();
    const timeFormat = useCompanyTimeFormat();
    const { selectedCellOrEvent } = useScheduleContext();

    const _breaks = useMemo(() => {
        const startDate = moment(selectedCellOrEvent?.startDate);
        return breaks.map((item: any) => ({
            ...item,
            start: typeof item.start === "number" ? moment(startDate).add(item.start, "seconds") : moment(item.start),
            end: typeof item.end === "number" ? moment(startDate).add(item.end, "seconds") : moment(item.end),
            duration: typeof item?.duration === "number"
                ? renderDurationAsFormat(item.duration, "HH:mm")
                : item.duration
        }));
    }, [selectedCellOrEvent?.startDate, breaks]);

    return (
        <div className="tw-w-full tw-mb-4 tw-flex tw-flex-col tw-gap-3">
            {_breaks?.length > 0 ? _breaks.map((item: any, index: number) => (
                <div
                    key={item.id || index}
                    className="tw-flex tw-items-center tw-gap-3 tw-rounded-lg tw-border tw-border-neutral-200/70 tw-bg-neutral-100/50 tw-px-4 tw-py-3"
                >
                    <div className="tw-flex tw-h-8 tw-w-8 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-primary/10 tw-text-primary">
                        <Coffee size={15} />
                    </div>

                    <div className="tw-flex tw-flex-1 tw-flex-col tw-min-w-0">
                        <span className="tw-text-sm tw-font-semibold tw-text-neutral-800">
                            {moment(item.start).format(timeFormat)}
                            <span className="tw-mx-1.5 tw-font-normal tw-text-neutral-400">→</span>
                            {moment(item.end).format(timeFormat)}
                        </span>
                        {item.payCode?.code && (
                            <span className="tw-text-xs tw-text-neutral-400 tw-mt-0.5">{item.payCode.code}</span>
                        )}
                    </div>

                    {item.duration && (
                        <span className="tw-shrink-0 tw-text-xs tw-font-medium tw-text-primary tw-bg-primary/10 tw-px-2.5 tw-py-1 tw-rounded-full">
                            {item.duration}
                        </span>
                    )}
                </div>
            )) : (
                <div className="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-py-3 tw-border tw-rounded-xl tw-border-dashed">
                    <img src="/assets/tea-cup.png" alt="" width={60} draggable="false" />
                    <p className="tw-text-sm tw-text-neutral-400 tw-italic tw-text-center">
                        {t("no-automatic-breaks-calculated")}
                    </p>
                </div>
            )}
        </div>
    );
}

export default AutomaticBreaksDisplay;
